/* ZWIM Frequency Optimizer — external (deferred). buildInputs() once; compute() on change, never rewrites inputs.
   Principles (Victor 29/05): pool days are the athlete's actual access (never capped). ZWIM is recommended ON TOP,
   never zero, but the number must be BELIEVABLE and validating, not pushy. For a sprint, Pool 2 + ZWIM 2 is a solid
   week and should read that way. The "why" is consistency + motor-skill consolidation between sessions, not dogma. */
(function(){
  var app=document.getElementById('ztf-app'); if(!app) return;
  var $=function(id){return document.getElementById(id);};
  // Believable recommended total swim-specific sessions/week, by race + level.
  var RT={
    sprint:{beginner:3,intermediate:3,advanced:4},
    olympic:{beginner:4,intermediate:4,advanced:5},
    '70.3':{beginner:4,intermediate:5,advanced:5},
    ironman:{beginner:5,intermediate:5,advanced:6}
  };
  var RACE={sprint:'sprint',olympic:'Olympic','70.3':'70.3',ironman:'Ironman'};
  var LIMNOTE={
    Consistency:'Consistency is your limiter, so ZWIM is your engine. The point is simple: a missed pool day never becomes a missed week. Anchor the pool days you can always make, and let ZWIM hold the frequency on the rest.',
    Speed:'Speed comes from propulsion. Keep your pool days for short, fast efforts and use ZWIM days to build catch-pull-push power, and watch your Propulsive Watts climb, without the pool fatigue that blunts fast work.',
    Technique:'Technique sticks through repetition. Use pool days for feel and feedback in the water; use ZWIM days to drill the catch and pull often between sessions, exactly when most athletes lose the pattern.',
    Endurance:'Endurance is built by repeatable volume. Make one pool day a longer continuous swim and use ZWIM days to add steady swim-specific work between pool trips.',
    'Open-water fear':'Open-water confidence comes from calm, repeatable reps. As race day nears, add an open-water session. Between them, ZWIM builds steady, repeatable propulsion so open water feels less chaotic.'
  };
  function setHero(big,cap,unitTxt){
    var b=$('ztf-big');$('ztf-cap').textContent=cap;$('ztf-bigunit').textContent=unitTxt;
    if(b.textContent!==big){b.textContent=big;b.classList.add('pulse');setTimeout(function(){b.classList.remove('pulse');},180);if(window.__zwimTrack)window.__zwimTrack('tool_calc_run',{tool:'frequency'});}
  }
  function chips(arr){return '<div class="ztf__chips">'+arr.map(function(c){return '<div class="ztf__chip"><div class="k">'+c.k+'</div><div class="v">'+c.v+'</div></div>';}).join('')+'</div>';}
  function buildInputs(){
    var inp=$('ztf-inputs');
    inp.innerHTML=''
      +'<div class="ztf__f"><label>Race distance</label><select id="i-race">'
        +'<option value="sprint">Sprint</option><option value="olympic" selected>Olympic</option>'
        +'<option value="70.3">70.3</option><option value="ironman">Ironman</option></select></div>'
      +'<div class="ztf__f"><label>Current level</label><select id="i-lvl">'
        +'<option value="beginner">Beginner</option><option value="intermediate" selected>Intermediate</option>'
        +'<option value="advanced">Advanced</option></select></div>'
      +'<div class="ztf__f"><label>Pool sessions you swim / week</label><input id="i-pool" value="2" inputmode="numeric" autocomplete="off"></div>'
      +'<div class="ztf__f"><label>Biggest limiter</label><select id="i-lim">'
        +'<option value="Endurance">Endurance</option><option value="Technique">Technique</option>'
        +'<option value="Consistency" selected>Consistency</option><option value="Speed">Speed</option>'
        +'<option value="Open-water fear">Open-water fear</option></select></div>';
    inp.querySelectorAll('input,select').forEach(function(e){e.addEventListener('input',compute);e.addEventListener('change',compute);});
  }
  function compute(){
    var race=(($('i-race')||{}).value)||'olympic';
    var lvl=(($('i-lvl')||{}).value)||'intermediate';
    var pool=Math.max(0, Math.min(14, Math.floor(+(($('i-pool')||{}).value)||0)));
    var lim=(($('i-lim')||{}).value)||'Consistency';
    var target=(RT[race]||RT.olympic)[lvl]||4;

    var meetsTarget=(pool>=target);
    var zwim, zwimOptional=false;
    if(meetsTarget){
      zwim=1; zwimOptional=true;               // pool already hits target → ZWIM optional, for activation + data
    } else {
      zwim=target-pool;                         // fill the gap to target
      if(lim==='Consistency') zwim+=1;          // consistency is exactly what ZWIM fixes best
      zwim=Math.max(1, Math.min(4, zwim));
    }
    var total=pool+zwim;
    var ow=(lim==='Open-water fear' || race==='70.3' || race==='ironman');
    var rl=RACE[race]||'race';

    setHero('Pool '+pool+' · ZWIM '+zwim+(zwimOptional?' (optional)':''), 'Your swim week', zwimOptional?(pool+' pool sessions already meets your target'):(total+' swim-specific sessions / week'));
    $('ztf-extra').innerHTML=chips([{k:'Pool days',v:pool},{k:(zwimOptional?'ZWIM (optional)':'ZWIM days'),v:zwim},{k:'Total / week',v:total}]);

    var notes=[];
    // 1. Validate their week first; believable, not pushy.
    if(meetsTarget){
      notes.push('Your '+pool+' pool sessions a week already meet a solid '+rl+' target, so keep all of them. You do not need more volume. ZWIM is optional here: one short session adds activation, propulsion data and a progress signal, ideally before a key set.');
    } else {
      notes.push('For a '+rl+', Pool '+pool+' + ZWIM '+zwim+' is a consistent, repeatable swim week. That consistency, not heroic single sessions, is what actually moves your swim.');
    }
    // 2. Why ZWIM is worth it at any volume (universal).
    notes.push('ZWIM earns its place at any swim volume: it primes you for the hard pool sets, builds propulsion-specific power, and gives you data to see progress between pool days.');
    // 3. Per-limiter guidance.
    notes.push(LIMNOTE[lim]||LIMNOTE.Consistency);
    // 4. Context notes.
    if(lvl==='beginner') notes.push('As a beginner, frequency beats intensity. Swimming is a skill, and skills are built by regular repetition. ZWIM lets you do swim-specific work more often without the fatigue or the pool logistics.');
    if(pool===0) notes.push('No pool access right now? ZWIM keeps your swim-specific work and your progress going until you’re back in the water. The pool stays where the full swim comes together.');
    if(ow) notes.push('Add an open-water session as race day nears, sighting, starts and chop can only be rehearsed in open water.');
    $('ztf-extra').innerHTML+=notes.map(function(n){return '<p style="margin:14px 0 0;font-size:13.5px;line-height:1.55;color:var(--text-2);text-align:left">'+n+'</p>';}).join('');

    $('ztf-hint').textContent='Your pool days are yours to keep. ZWIM fills the gap to your target, or adds activation and data when you are already there.';
  }
  buildInputs(); compute();
})();
